import qz from "qz-tray";

let printerCache = null;

export const initializeQZ = async () => {
    if (printerCache) {
        return printerCache;
    }

    if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
    }

    printerCache = await qz.printers.find();

    return printerCache;
};

// Get available printers
export const getPrinters = async () => {
    const printers = await qz.printers.find();
    console.log("Printers:", printers);
    return printers;
};

// Print ESC/POS raw data
// export const printReceipt = async (printerName, data) => {
//     if (!qz.websocket.isActive()) {
//         await qz.websocket.connect();
//     }

//     const config = qz.configs.create(printerName, {
//         encoding: "UTF-8"
//     });

//     await qz.print(config, data);
// };

// export const getInstalledPrinters = async () => {
//     try {
//         return await qz.printers.find();
//     } catch (error) {
//         console.error(error);
//         return [];
//     }
// };

// export const printToPrinter = async (printerName, data) => {
//     try {
//         if (!qz.websocket.isActive()) {
//             await qz.websocket.connect();
//         }

//         const config = qz.configs.create(printerName);

//         await qz.print(config, data);

//         return true;
//     } catch (error) {
//         console.error(error);
//         throw error;
//     }
// };
